import { CSSProperties, PropsWithChildren, ReactNode } from "react";

import { cn } from "shared/utils/cn";

import { Skeleton } from "./skeleton";

export type Props = {
  isLoading?: boolean;
  className?: string;
  expirationDate: number;
  view: "big" | "small";
  title: string;
  background?: string;
  bgImage?: string;
  icon?: ReactNode;
  cardClassName?: string;
  iconWrapperClassName?: string;
  style?: CSSProperties;
};

{
  /* <CertCard
  title="Sample KYC Certificate"
  background="from-transparent to-azure/8"
  bgImage="https://galactica.com/assets/images/home/bg-bottom-sm.webp"
  view="big"
  icon={<GalacticaLogo className="place-center size-9" />}
  expirationDate={Date.now() + 10000000}
/>; */
}

export const Card = ({
  view,
  expirationDate,
  isLoading,
  title,
  background,
  bgImage,
  icon,
  iconWrapperClassName,
  cardClassName,
  style,
  children,
}: PropsWithChildren<Props>) => {
  if (isLoading) return <Skeleton className="w-full" width="100%" />;

  return (
    <div className="relative flex h-px pb-[62%]">
      <div
        className={cn(
          "absolute inset-0",
          "bg-whiteSmoke z-10 flex w-full flex-col overflow-hidden rounded-[14px] border border-black/4",
          "bg-cover bg-no-repeat shadow-xl",
          cardClassName
        )}
        style={{
          backgroundImage: bgImage ? `url(${bgImage})` : undefined,
          ...style,
        }}
      >
        <div
          className={cn(
            "absolute left-0 h-full overflow-hidden",
            view === "big" && "w-4/5",
            view === "small" && "w-full"
          )}
        >
          <div className="place-center absolute size-[200%] -rotate-45">
            {Array(40)
              .fill(title)
              .map((e, i) => (
                <span
                  className="text-balticSea/2 mr-4 text-lg leading-[30px] font-semibold"
                  key={i}
                >
                  {e}
                </span>
              ))}
          </div>
        </div>
        <div
          className={cn("absolute z-0 size-full bg-linear-to-r", background)}
        />
        <div className="relative z-10 flex flex-col px-6 py-5">
          <div className="flex items-start justify-between">
            <div className="flex items-center justify-between">
              <div
                className={cn(
                  "border-alabaster relative size-16 rounded-[10px] border bg-white",
                  iconWrapperClassName
                )}
              >
                {icon}
              </div>
            </div>
            <div className="text-riverBed/70 opacity-0">
              <div className="text-xs">Expiry date</div>
              <div className="text-sm">
                {new Date(expirationDate).toDateString()}
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-4 left-6 text-current">
          <div className="text-sm leading-5 font-medium">
            {/* Your {expirationDate <= Date.now() ? "expired" : "active"}{" "}
            zkCertificate */}
            Your zkCertificate
          </div>
          <div className="text-2xl leading-8 font-semibold">{title}</div>
        </div>

        {children}
      </div>
    </div>
  );
};
